import { render, staticRenderFns } from "./EventsInsights.vue?vue&type=template&id=50406ab8"
import script from "./EventsInsights.vue?vue&type=script&lang=js"
export * from "./EventsInsights.vue?vue&type=script&lang=js"
import style0 from "./EventsInsights.vue?vue&type=style&index=0&id=50406ab8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports